/* eslint-disable */
import { produce } from "immer";
import {
  POST_YOUR_GOALS_FETCH_START,
  POST_YOUR_GOALS_FETCH_SUCCESS,
  POST_YOUR_GOALS_FETCH_FAILURE,
} from "../actions/types";

const yourGoalsPost = (
  state = {
    fetching: false,
    data: {},
    error: null,
  },
  action,
) => {
  switch (action.type) {
    case POST_YOUR_GOALS_FETCH_START:
      return produce(state, (draft) => {
        draft.fetching = true;
      });
    case POST_YOUR_GOALS_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.fetching = true;
        draft.data = action.data;
        draft.fetching = false;
      });
    case POST_YOUR_GOALS_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.fetching = false;
        draft.error = action.error;
      });
    default:
      return state;
  }
};

export default yourGoalsPost;
